module.exports = __webpack_public_path__ + "img/00036.c91fd6b2.webp";